import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";

import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { VisitorsRegMorePage } from '../visitors-reg-more/visitors-reg-more';
import { LoginPage } from '../login/login';
import { CalendarPage } from '../calendar/calendar';
import { VideoPage } from '../video/video';
import { DirectionsPage } from '../directions/directions';
import { SecurityhomePage } from '../securityhome/securityhome';

//@IonicPage()
@Component({
  selector: 'page-checkin',
  templateUrl: 'checkin.html',
})
export class CheckinPage {
  private vistor_checkin : FormGroup;
  
  accessCode = "";
  authtoken = "";
  viscode = "";

  reason = "";
  visited = "";
  declaration = "";
  prodsno = "";

  validation_messages = {
    'visited': [
      { type: 'required', message: '*Please enter visited.' },
    ],
    'reason': [
      { type: 'required', message: '*Please enter a reason.' },
    ],
    'declaration': [
      { type: 'required', message: '*Please enter a declaration.' },
    ],
    'prodsno': [
      { type: 'required', message: '*Please enter product serial number.' },
    ],
  }


  constructor( 
      private formBuilder: FormBuilder,  
      public navCtrl: NavController, 
      private toastCtrl: ToastController, 
      public navParams: NavParams,     
      public http: HttpClient,   
      public actionSheetCtrl: ActionSheetController, 
      public platform: Platform, 
      public loadingCtrl: LoadingController ,
      private storage: Storage,
      public global: GlobalProvider
    ) {
    
    this.vistor_checkin = this.formBuilder.group({
      visited: ['', Validators.required],
      reason: ['', Validators.required],
      declaration: [''],// ['', Validators.required],
      prodsno: [''],//['', Validators.required],
    });

    this.storage.get('accesscode').then((val) => {
      console.log('acc = '+val);
      this.accessCode = val;
      this.storage.get('Authorization').then((val1) => {
        this.authtoken = val1;
        console.log('auth = '+this.authtoken);
        this.viscode = this.navParams.get('viscode');
      });
      
    });
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CheckinPage');
  }

  goback(){
    this.navCtrl.pop();
  }

  checkin(){
    //(<HTMLInputElement> document.getElementById('checkIn')).disabled=true;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let postData = JSON.stringify({
      "checkinDTO": {
        "declaration": [
          this.declaration
        ],
        "personVisited": this.visited,
        "productSerial": [
          this.prodsno
        ],
        "reasonForVisit": [
          this.reason
        ],
        "verificationCode": this.viscode
      }
    });

    //console.log(postData);
    
    this.http.post(this.global.baseUrl+"api/admin/checkin", postData, httpOptions)
      .subscribe((data:any) => {
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('checkIn')).disabled=false;
          }else{
            console.log(data.visitorDTO);
            let toast = this.toastCtrl.create({
              message: 'Check-In added successfully',
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('checkIn')).disabled=false;
            
            this.navCtrl.push(SecurityhomePage);
          }
        }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 5000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
          //(<HTMLInputElement> document.getElementById('checkIn')).disabled=false;
          
      });
  }

  badgeIss(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let postData = JSON.stringify({
      "badgeIssueDTO": {
        "declaration": [
          this.declaration
        ],
        "personVisited": this.visited,
        "productSerial": [
          this.prodsno
        ],
        "reasonForVisit": [
          this.reason
        ],
        "verificationCode": this.viscode
      }
    });

    const url = this.global.baseUrl+"api/admin/badge/issue";

    this.http.post(url ,postData, httpOptions)//requestOpt)
      .subscribe((data:any) => {
          if(data.error == true){
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            console.log(data.visitorDTO);
            let toast = this.toastCtrl.create({
              message: "Badge Issued successfully!.",
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            this.navCtrl.push(SecurityhomePage);
          }
        }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 5000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
          
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/checkin/checkin.ts